<template>
  <div id="shop">
    <!-- header image -->
    <v-container fluid pa-0>
      <v-layout align-center justify-center row wrap>
        <v-flex pt-0 sm6 xs12>
          <v-img :src="require('@/assets/shop/shop_header.png')" width="100%"></v-img>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- content -->
    <v-container grid-list-xl pt-0>
      <v-layout align-center justify-center row wrap>
        <v-flex pt-0 px-0 sm8 xs12>
          <v-img :src="require('@/assets/shop/shop_header-1.png')" width="100%"></v-img>
        </v-flex>
      </v-layout>

      <v-layout
        align-center
        justify-center
        :key="item.idx"
        row
        v-for="(item, index) in shopProducts"
        wrap
      >
        <v-flex sm8 text-xs-center xs12>
          <!-- ketword & desc -->
          <v-layout align-center justify-center row wrap>
            <v-flex sm8 text-xs-center xs12>
              <div class="headline font-weight-bold">"{{ item.keyword }}"</div>
              <div class="body-2 spacing-2 mt-2">"{{ item.description }}"</div>
            </v-flex>
          </v-layout>
          <v-layout align-center justify-center row wrap>
            <!-- month -->
            <v-flex sm8 text-xs-center xs12>
              <div class="bg-product pt-4" :style="{ backgroundImage: 'url(' + image + ')' }">
                <!-- <template v-slot:default> -->
                <div class="subheading spacing-2 font-weight-bold">
                  ผลผลิตพร้อมเก็บเกี่ยวของเดือน
                </div>
                <div class="caption font-weight-bold">{{ item.hashtag }}</div>
                <v-card class="card-shop-edition mt-2" elevation="0" v-if="index === 0">
                  <v-card-text>
                    <v-layout align-center justify-center row wrap>
                      <v-flex text-xs-center xs12>
                        <div class="display-1 font-weight-bold" style="color:#385723">
                          {{ monthNames[currentMonth] }}
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
                <ShopProdctList :shopEditionId="item.idx" />
                <!-- </template> -->
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <!-- Banners -->
      <v-layout align-center justify-center row wrap>
        <v-flex sm6 text-xs-center xs11>
          <base-banners bannerPositionId="BANNERPOS0000011" pageId="PAGES0000007"></base-banners>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
const ShopProdctList = () => import('@/components/shop/ShopProductList')
export default {
  name: 'shop',
  components: {
    ShopProdctList
  },
  data() {
    return {
      image: require('@/assets/shop/shop_bg.png'),
      currentMonth: new Date().getMonth(),
      shopProducts: [],
      monthNames: [
        'มกราคม',
        'กุมภาพันธ์',
        'มีนาคม',
        'เมษายน',
        'พฤษภาคม',
        'มิถุนายน',
        'กรกฎาคม',
        'สิงหาคม',
        'กันยายน',
        'ตุลาคม',
        'พฤศจิกายน',
        'ธันวาคม'
      ]
    }
  },
  mounted() {
    this.fetchShopProduct()
  },
  methods: {
    async fetchShopProduct() {
      try {
        const response = await this.axios.get(`farmerspace/shop/edition`)
        this.shopProducts = response.data
      } catch (error) {
        throw new Error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card-shop-edition {
  background-color: rgba(250, 240, 176, 0.7);
  border-radius: 16px;
  .display-2 {
    opacity: 1;
  }
}
.spacing-2 {
  letter-spacing: 2px !important;
}
.bg-product {
  width: 100%;
  min-height: 300px;
  background-size: contain;
  background-position: top center;
}
</style>
